import { Col, Empty, Row } from 'antd';
import {
  getVideoProgressInPercentage,
  secondsToMinute
} from '../../../../common/utils';
import PodcastListLoading from '../../../skeleton/PodcastListLoading';
import SectionHeader from '../../SectionHeader/SectionHeader';
import PodcastCard from './PodcastCard';

function PodcastList({
  sectionHeading,
  headerLink,
  headerDescription,
  data = [],
  videoSelect,
  videoSelectCheckbox,
  selectedVideoIds,
  videoDelete,
  handleDelete,
  separator,
  showVideoProgressBar,
  videosWatchTimes,
  dropdownItems,
  handleDropdownItemClick,
  instanceData,
  instanceId,
  instanceType
}) {
  return (
    <section className={`video-list-grid ${!separator ? 'separator-off' : ''}`}>
      <div className="container">
        <SectionHeader
          heading={sectionHeading}
          headerLink={headerLink}
          headerDescription={headerDescription}
        />
      </div>

      <div className="container-rnp">
        {!data?.length && (
          <Empty
            className="text-md-bold"
            image="/images/no-videos.svg"
            description="No Videos!"
          />
        )}
        <Row>
          {data?.map((item) => {
            return (
              <Col
                key={item?.id}
                xs={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
              >
                <PodcastCard
                  dropdownItems={dropdownItems}
                  isList
                  videoId={item?.id}
                  videoDelete={videoDelete}
                  videoSelect={videoSelect}
                  src={item?.src}
                  videoThumbnail={item?.videoThumbnail}
                  blurhash={item?.blurhash}
                  defaultValue={item?.defaultValue}
                  time={secondsToMinute(item?.time)}
                  topics={item?.topics}
                  collection={item?.collection}
                  title={item?.title}
                  date={item?.date}
                  tags={item?.tags}
                  tagBackground={item?.tagBackground}
                  tagTextColor={item?.tagTextColor}
                  videoDescription={item?.videoDescription}
                  handleDelete={handleDelete}
                  href={item?.href}
                  handleDropdownItemClick={handleDropdownItemClick}
                  {...(videoSelect && {
                    videoSelectCheckbox: (e) => videoSelectCheckbox(e, item),
                    isVideoSelected: selectedVideoIds?.includes(item?.id)
                  })}
                  {...(showVideoProgressBar && {
                    defaultValue: getVideoProgressInPercentage(
                      videosWatchTimes?.[item?.id],
                      item?.time
                    )
                  })}
                  instanceData={instanceData}
                  instanceId={instanceId}
                  instanceType={instanceType}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}

PodcastList.Loading = function Loading() {
  return <PodcastListLoading />;
};
export default PodcastList;
